var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaunchPartnersSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.218,
    height: 41.538,
    viewBox: "0 0 38.218 41.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Launch_Partners",
    "data-name": "Launch Partners",
    transform: "translate(2.32 0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46221",
    transform: "translate(1.848 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16531",
    width: 2.679,
    height: 6.847,
    transform: "translate(12.131 26.27)",
    fill: "#1227f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2013",
    cx: 13.47,
    cy: 13.47,
    r: 13.47,
    transform: "translate(0)",
    fill: "#02eec4",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98377",
    d: "M19.493,22.428A13.355,13.355,0,0,1,9.372.4a13.348,13.348,0,0,0,4.316,26.345,13.648,13.648,0,0,0,7.963-4.465,21.025,21.025,0,0,1-2.158.149Z",
    transform: "translate(1.94 -0.102)",
    fill: "#1227f2",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46224",
    transform: "translate(-1.97 20.536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46222",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98378",
    d: "M46.035,24.178c.372.447.6.447.372.67-.149.149-.521,0-.967-.074a3.627,3.627,0,0,1-.819-.3A2.262,2.262,0,0,1,44.1,24.1a.7.7,0,0,0,.819-.6v-.074c.074,0,.149.074.149,0a3.15,3.15,0,0,0,.521-.372,1.268,1.268,0,0,1,1.042,0c.372.223.6.521.372.67,0,.074-1.191.223-.967.447Z",
    transform: "translate(-9.815 -11.229)",
    fill: "#ff955c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98379",
    d: "M44.9,23.35a.746.746,0,0,1-.744.744h-.074l-.3-.3c-.223-.3.521-1.116.67-.819a1.973,1.973,0,0,0,.447.372Z",
    transform: "translate(-9.724 -11.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98380",
    d: "M40.747,12.8a.579.579,0,0,1,.149.6.387.387,0,0,1-.149.3H40.6a.447.447,0,0,1-.3-.074A1.774,1.774,0,0,0,40.747,12.8Z",
    transform: "translate(-8.843 -8.632)",
    fill: "#ff955c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98381",
    d: "M38.8,16.1a7.514,7.514,0,0,1,1.191.967c.3.372.074,1.563-.149,2.084a10.605,10.605,0,0,0-.819-.893L38.5,16.249C38.649,16.174,38.723,16.1,38.8,16.1Z",
    transform: "translate(-8.382 -9.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98382",
    d: "M42.4,21.926c-.372-.521-1.563-1.935-2.456-2.9.149-.521.447-1.637.149-2.084a7.514,7.514,0,0,0-1.191-.967.409.409,0,0,0,.223-.372,1.984,1.984,0,0,1,1.042.521A7.558,7.558,0,0,1,41.8,18.5c.819,1.414,1.34,2.158,1.786,2.828a.273.273,0,0,1,.074.223c-.149-.149-.372-.3-.447-.447-.149-.223-.893.521-.67.819.074.149.223.223.3.3a.683.683,0,0,1-.447-.3Z",
    transform: "translate(-8.485 -9.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98383",
    d: "M40.2,14.149,40.349,14c.074.074.149.074.3.074H40.8a.84.84,0,0,1-.6.074Z",
    transform: "translate(-8.817 -8.939)",
    fill: "#ff955c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98384",
    d: "M40.555,12.649c.074,0,.149.074.223.074a1.774,1.774,0,0,1-.447.819l-.074-.074c-.149-.074-.149-.223-.074-.372v-.074l.223-.521a.16.16,0,0,0,.149.149Z",
    transform: "translate(-8.8 -8.556)",
    fill: "#ff955c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98385",
    d: "M40.423,12.7c-.074,0-.149.074-.223.074A.273.273,0,0,1,40.423,12.7Z",
    transform: "translate(-8.817 -8.607)",
    fill: "#ffd9bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98386",
    d: "M38.947,19.485l-3.423-1.34-.223-.223v-1.1L39.144,18.9h0Z",
    transform: "translate(-7.564 -9.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98387",
    d: "M40.1,12.674a.273.273,0,0,0,.223-.074h0l-.223.521a.332.332,0,0,0,0,.372h.074a.073.073,0,0,1,.074.074c-.074.074-.074.149-.149.149a.581.581,0,0,1-.3-.3l.3-.744Z",
    transform: "translate(-8.715 -8.581)",
    fill: "#ff955c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98388",
    d: "M38.4,15.7a1.307,1.307,0,0,1,.372.3c-.074.074-.149.074-.3.149Z",
    transform: "translate(-8.357 -9.374)",
    fill: "#ff955c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98389",
    d: "M38.747,15.921a1.307,1.307,0,0,1-.372-.3L38.3,15.4a2.06,2.06,0,0,1,.67.074.643.643,0,0,1-.223.447Z",
    transform: "translate(-8.331 -9.298)",
    fill: "#ff955c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98390",
    d: "M35.148,17.413A1.9,1.9,0,0,1,35,15.18a1.5,1.5,0,0,1,1.563-.223v.372a.509.509,0,0,0,.521.521.944.944,0,0,0,.447-.074l.521,2.009c.149.149.447.521.819.893v.074l-3.647-2.158a2.79,2.79,0,0,1-.074.819Z",
    transform: "translate(-7.412 -9.152)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98391",
    d: "M37.821,15.993a.509.509,0,0,1-.521-.521V15.1c.074,0,.223.074.3.074a4.154,4.154,0,0,1,.6.372l.074.372a.944.944,0,0,1-.447.074Z",
    transform: "translate(-8.075 -9.221)",
    fill: "#ff955c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98392",
    d: "M38.763,14.541a2.265,2.265,0,0,1-1.563.074v-.372s.447-.372.6-.3.893-.6.967.372Z",
    transform: "translate(-8.05 -8.885)",
    fill: "#ff955c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98393",
    d: "M38.093,15.5a6.864,6.864,0,0,0-.6-.372.447.447,0,0,0-.3-.074v-.074a2.265,2.265,0,0,0,1.563-.074v.6a2.06,2.06,0,0,0-.67-.074V15.5Z",
    transform: "translate(-8.05 -9.17)",
    fill: "#ff955c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98394",
    d: "M36.99,12.43v-.372c0-.149.074-.149.223-.074s.6.447.67.447.149.074.149.223v.521c0,.074-.149.149-.3.074a4.128,4.128,0,0,1-.6-.447C36.99,12.653,36.916,12.579,36.99,12.43Z",
    transform: "translate(-7.988 -8.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98395",
    d: "M36.771,10.221h-.084a.632.632,0,0,1-.587-.432h0a2.358,2.358,0,0,1,3.44.086,2.412,2.412,0,0,1,.587,2.332.3.3,0,0,0-.252-.086h-.168a.3.3,0,0,0-.252.086c-.252,0-.336-.259-.252-.345a.272.272,0,0,1-.252-.259V11.43c0-.086,0-.043.084-.13h-.084v-.129h0a.366.366,0,0,1-.336-.345h0a.3.3,0,0,1-.252.086h0c-.168,0-.252-.086-.336-.259-.084.086-.168.173-.252.173h0a.366.366,0,0,1-.336-.345v-.086c-.084.086-.168.173-.252.173h0c-.252.086-.419-.086-.419-.345Z",
    transform: "translate(-8.142 -7.742)",
    fill: "#3c4ef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98396",
    d: "M35.87,8.167V7.944c.074-.149.223-.3.372-.223h.074c-.074-.074-.149-.223-.074-.3a.409.409,0,0,1,.372-.223c.149.074.3.223.447.3,0-.074,0-.074.074-.149.074-.149.3-.149.447-.074h0L37.8,7.5h.149c0-.074,0-.149.074-.149.074-.149.3-.149.447-.074h0a1.544,1.544,0,0,1,.447.744A.073.073,0,0,1,39,7.944a.279.279,0,0,1,.447,0,1.2,1.2,0,0,1,.3.521.073.073,0,0,0,.074-.074.358.358,0,0,1,.447.149,2.06,2.06,0,0,1,.074.67h0a.32.32,0,0,1,.3.3h0a1.546,1.546,0,0,1-.372.893.447.447,0,0,1-.074.3c-.074.074-.149.149-.223.149h.074a.636.636,0,0,1,0,.521c-.074.074-.074.074-.149.074l.074.074a.327.327,0,0,1-.074.372h0c-.223.3-.372.372-.447.372a.387.387,0,0,0,.149-.3.579.579,0,0,0-.149-.6,2.232,2.232,0,0,0-1.563-2.679,2.171,2.171,0,0,0-2.009.521h-.112c0-.447-.111-.6-.26-.6a.3.3,0,0,1,0-.6h0c.074.074.223.074.372.149Z",
    transform: "translate(-7.538 -7.2)",
    fill: "#3c4ef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98397",
    d: "M34.766,23.863A1.807,1.807,0,0,1,34.1,22.3a2.272,2.272,0,0,1,.67.372,4.265,4.265,0,0,1,.819.819s2.084-.3,2.381,0l.074.074-.074.074c-.223.372-1.34.967-2.9.3-.074,0-.223-.074-.3-.074Z",
    transform: "translate(-7.253 -11.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98398",
    d: "M35.289,11.544h0a2.2,2.2,0,0,1,.149-.744c.149.149.521.372.6.447s.149.074.149.223v.521c0,.074-.149.149-.3.074a3.727,3.727,0,0,1-.6-.521Z",
    transform: "translate(-7.552 -8.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98399",
    d: "M35.711,10c.074.223.3.3.521.372h.074v.074a.32.32,0,0,0,.3.3h0c.074,0,.223-.074.223-.149v.074a.32.32,0,0,0,.3.3h0c.074,0,.223-.074.223-.149.074.149.149.223.3.223h0c.074,0,.149-.074.223-.074h0a.32.32,0,0,0,.3.3h.074a.073.073,0,0,0,.074.074c-.074,0-.074.074-.149.149-.074.149,0,.223.074.3h.149c-.074.074,0,.3.223.3h0l1.124.181c.074.149-1.273.861-1.124.936l-.074.074a1.62,1.62,0,0,1-.6.372v-.223c0-.967-.286-.223-.509-.223a2.34,2.34,0,0,0-.68.223l-.374.3a2.135,2.135,0,0,1-1.488-2.381A9.289,9.289,0,0,0,35.711,10Z",
    transform: "translate(-7.454 -7.916)",
    fill: "#ff955c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98400",
    d: "M34.521,19.863a2.929,2.929,0,0,0,.447-1.563l.223.223,3.423,1.34a.23.23,0,0,1,.074-.149h0c-.6.967-.372,2.233-.744,2.828a.073.073,0,0,0-.074-.074c-.223-.3-2.274.216-2.274.216a6.137,6.137,0,0,0-.927-1.034,4.29,4.29,0,0,0-.67-.372,7.936,7.936,0,0,1,.521-1.414Z",
    transform: "translate(-7.231 -10.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98401",
    d: "M35.1,10.858c0-.149.074-.149.223-.074a.073.073,0,0,1,.074.074l-.223.67c-.074-.074-.074-.149-.074-.3v-.372Z",
    transform: "translate(-7.512 -8.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98403",
    d: "M32.1,23.9a1.472,1.472,0,0,1,.819.149L32.1,23.9Z",
    transform: "translate(-6.745 -11.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98404",
    d: "M32.967,23.921a1.033,1.033,0,0,0-.819-.149c-.074,0-.074-.074-.149-.074a.387.387,0,0,0,.149-.3,1.076,1.076,0,0,1,.521.149l1.563.6Z",
    transform: "translate(-6.72 -11.344)",
    fill: "#c2c7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98405",
    d: "M32.1,23.874l-.3-.074c.074.074.149.074.3.074Z",
    transform: "translate(-6.668 -11.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98406",
    d: "M31.974,23.7l.149.074H31.9l.074-.074Z",
    transform: "translate(-6.694 -11.421)",
    fill: "#ffd9bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98407",
    d: "M31.921,23.389a.564.564,0,0,1-.149.3,1.627,1.627,0,0,0-.372-.223C31.623,23.389,31.772,23.315,31.921,23.389Z",
    transform: "translate(-6.566 -11.333)",
    fill: "#c2c7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98408",
    d: "M31.775,22.679a1.38,1.38,0,0,0-.521-.149.723.723,0,0,0-.074-.67A8.8,8.8,0,0,0,29.1,20.223,5.128,5.128,0,0,0,28.5,20a17.479,17.479,0,0,1,4.242,1.712,1.636,1.636,0,0,0,.67,1.563h0C33.337,23.274,32.444,22.9,31.775,22.679Z",
    transform: "translate(-5.824 -10.474)",
    fill: "#c2c7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98409",
    d: "M31.8,23.9Z",
    transform: "translate(-6.668 -11.472)",
    fill: "#ffd9bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98410",
    d: "M31.372,23.4l.372.223c0,.074-.074.074-.074.149L31,23.623a1.627,1.627,0,0,1,.372-.223Z",
    transform: "translate(-6.464 -11.344)",
    fill: "#ff955c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98411",
    d: "M30.923,23.7l.67.074h0a2.173,2.173,0,0,0-.67.149c-.074,0-.149.074-.223.074.074-.074.074-.074.074-.149l.149-.149Z",
    transform: "translate(-6.387 -11.421)",
    fill: "#ff955c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98412",
    d: "M30.747,24.049a2.173,2.173,0,0,1,.67-.149,2.122,2.122,0,0,1-1.042.6.073.073,0,0,1-.074-.074l.223-.3A.273.273,0,0,1,30.747,24.049Z",
    transform: "translate(-6.285 -11.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98413",
    d: "M31.065,23.251a1.627,1.627,0,0,0-.372.223l-.3-.074c-.223-.149-.372-.223-.6-.372a.678.678,0,0,1,.893-.074.743.743,0,0,0,.372.3Z",
    transform: "translate(-6.157 -11.195)",
    fill: "#ff955c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98414",
    d: "M30.986,22.53a1.453,1.453,0,0,0-.521.074,1.627,1.627,0,0,1-.372-.223c-.3-.223-.794,0-1.017.223a3.8,3.8,0,0,0-.844-.295c-.893-.223-.3-2.31-.223-2.31h.223a.99.99,0,0,1,.6.223,11.239,11.239,0,0,1,2.084,1.637.554.554,0,0,1,.074.67Z",
    transform: "translate(-5.631 -10.474)",
    fill: "#c2c7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98415",
    d: "M31.814,23.974c.223.223-1.042.819-1.265.67-.074-.074-.149-.074-.149-.149a1.629,1.629,0,0,0,1.042-.6h0l.372.074Z",
    transform: "translate(-6.31 -11.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98416",
    d: "M30.472,24.2l-.223.3-.149-.149A1.257,1.257,0,0,0,30.472,24.2Z",
    transform: "translate(-6.234 -11.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98417",
    d: "M32.449,24.37a1.4,1.4,0,0,1-1.116,1.563c-1.34.447-2.009.223-2.233-.223.3-.447.344-.819.567-1.116.074,0,.258-.16.332-.16.074.074.843-.51.843-.435.149.149.788.223.565,0h0l.744.149c.149,0,.223.074.3.223Z",
    transform: "translate(-5.978 -11.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98418",
    d: "M30.274,24.6h0l-.074.074A.073.073,0,0,0,30.274,24.6Z",
    transform: "translate(-6.259 -11.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98419",
    d: "M30.147,24.549a.073.073,0,0,1-.074.074H29.7c.074-.074.223-.149.3-.223a.16.16,0,0,0,.149.149Z",
    transform: "translate(-6.131 -11.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98420",
    d: "M30.409,23.821a.26.26,0,0,0-.074.149,1.627,1.627,0,0,0-.372.223l-.3-.3a.394.394,0,0,1,.074-.6h0c.223.074.744.071.893.22v.227C30.557,23.672,30.483,23.747,30.409,23.821Z",
    transform: "translate(-6.096 -11.318)",
    fill: "#ff955c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98421",
    d: "M29.888,24.674c-.223.3-.521.67-.819,1.116,0-.074-.074-.074-.074-.149a1.144,1.144,0,0,1,.447-1.042c.223.149.3.149.447.074Z",
    transform: "translate(-5.947 -11.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98422",
    d: "M30.751,25.961A1.4,1.4,0,0,0,31.867,24.4a.581.581,0,0,0-.3-.3l1.265.223h0a.564.564,0,0,0,.3.149,2.477,2.477,0,0,0,2.9-.3l.074-.074a1.543,1.543,0,0,1-.447,2.084c-.074.074-.149.074-.3.149a5.785,5.785,0,0,1-3.721-.149c-.6-.149-.744.372-.967.67s-1.265,1.637-1.712,2.233a1.257,1.257,0,0,1-.744.223h0a.677.677,0,0,0,0-.893.26.26,0,0,0-.149-.074,1.057,1.057,0,0,0-1.191.3.815.815,0,0,1,0-.6,19.191,19.191,0,0,1,1.488-2.158,2.9,2.9,0,0,0,2.381.074Z",
    transform: "translate(-5.396 -11.523)",
    fill: "#c2c7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98423",
    d: "M28.365,30.643a1.657,1.657,0,0,1-1.265-.67,1.029,1.029,0,0,1,1.191-.3.617.617,0,0,1,.223.819.16.16,0,0,0-.149.149Z",
    transform: "translate(-5.466 -12.931)",
    fill: "#c2c7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98424",
    d: "M28.621,23.523a6.69,6.69,0,0,1-1.935-1.265,1.314,1.314,0,0,1,.967-2.158c-.149.074-.6,1.935.372,2.158a2.666,2.666,0,0,1,.819.3.394.394,0,0,0-.074.6h0l.3.3c-.074.074-.223.149-.3.223,0-.149-.074-.149-.149-.149Z",
    transform: "translate(-5.276 -10.5)",
    fill: "#c2c7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98425",
    d: "M28.349,20h0Z",
    transform: "translate(-5.748 -10.474)",
    fill: "#c2c7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98426",
    d: "M28.135,30.744c-.149.149-.3.223-.447.372l-.149-.149a1.25,1.25,0,0,0-1.34-.149c.223-.3.521-.67.6-.819a2.042,2.042,0,0,0,1.34.744Z",
    transform: "translate(-5.236 -13.032)",
    fill: "#ff955c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98427",
    d: "M27.5,31.135c.074,0,.074.074.149.149a3.727,3.727,0,0,1-.6.521c-.447.3-1.191-.149-.967-.6,0-.074.329-.369.4-.443.372-.3.639.071,1.011.369Z",
    transform: "translate(-5.196 -13.2)",
    fill: "#ff955c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98428",
    d: "M25.392,31.349c-.3.372.447.893.967.6a2.006,2.006,0,0,0,.6-.521c.372.447-.149,1.116-.893,1.563-.819.447-1.563.967-2.381.521s-.074-1.34,1.042-1.935c.223-.149.521-.223.744-.372a.26.26,0,0,0-.074.149Z",
    transform: "translate(-4.503 -13.339)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98430",
    d: "M18.342,30.828c0-.372-.6-.819-1.042-1.116l.223-.223c.521-.223.744.67.819,1.34Z",
    transform: "translate(-2.959 -12.892)",
    fill: "#02eec4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98431",
    d: "M18.042,31.214a1.547,1.547,0,0,1-.819.074L17,31.065h0a2.446,2.446,0,0,1,.3-1.265c.447.3,1.042.744,1.042,1.116a.581.581,0,0,1-.3.3Z",
    transform: "translate(-2.883 -12.981)",
    fill: "#02eec4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98432",
    d: "M17.174,31.672a1.478,1.478,0,0,0,.819-.074c.149-.074.223-.149.223-.3h0c0,.223.074.372.074.6,0,.447.149,1.488-.447,1.637a.819.819,0,0,1-.744-.447c.3,0,.67-.744.223-1.265l-.149-.149Z",
    transform: "translate(-2.908 -13.365)",
    fill: "#02eec4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98433",
    d: "M17.372,31.923a.766.766,0,0,1-.223,1.265,2.173,2.173,0,0,1-.149-.67V31.7c.074,0,.149.074.223.074a.16.16,0,0,0,.149.149Z",
    transform: "translate(-2.883 -13.467)",
    fill: "#02eec4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98434",
    d: "M16.9,31.5l.223.223c-.074,0-.149-.074-.223-.074V31.5Z",
    transform: "translate(-2.857 -13.416)",
    fill: "#02eec4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98435",
    d: "M16.891,29.6a2.446,2.446,0,0,0-.3,1.265,10.1,10.1,0,0,1-.893-.893c.223-.074.372-.223.3-.372,0-.149-.074-.372-.074-.6l.67.447c.074,0,.149.074.3.149Z",
    transform: "translate(-2.55 -12.776)",
    fill: "#02eec4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98436",
    d: "M15.5,30.3a10.1,10.1,0,0,1,.893.893h0v.149a3.774,3.774,0,0,1-1.191-.67l-.3-.3a1.451,1.451,0,0,0,.6-.074Z",
    transform: "translate(-2.345 -13.109)",
    fill: "#ffe1cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98437",
    d: "M14.6,29.157a.409.409,0,0,1,.223-.372.811.811,0,0,1,.819.149,2.394,2.394,0,0,1,.074.6.38.38,0,0,1-.3.372c-.3-.3-.6-.521-.819-.744Z",
    transform: "translate(-2.269 -12.71)",
    fill: "#ffe1cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98438",
    d: "M13.4,26.433c-.149-.582,1.563-1.164,1.637-.582h0C15.034,26.516,13.843,26.931,13.4,26.433Z",
    transform: "translate(-1.959 -12.018)",
    fill: "#c2c7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98439",
    d: "M14.8,30.119a1.561,1.561,0,0,1-.3-.819,8.148,8.148,0,0,0,.819.744A.564.564,0,0,1,14.8,30.119Z",
    transform: "translate(-2.243 -12.853)",
    fill: "#ffe1cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98440",
    d: "M14.516,28.084a.409.409,0,0,0-.223.372,1.973,1.973,0,0,0-.447-.372h0c-.149-.6-.372-1.265-.447-1.563.447.447,1.637.074,1.637-.521.074.67.149,1.563.3,2.233a1.146,1.146,0,0,0-.819-.149Z",
    transform: "translate(-1.962 -12.009)",
    fill: "#ffe1cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98441",
    d: "M14.447,29.172a1.119,1.119,0,0,0,.3.819.472.472,0,0,1-.447-.372A5.653,5.653,0,0,0,14,28.8h0a1.973,1.973,0,0,1,.447.372Z",
    transform: "translate(-2.115 -12.725)",
    fill: "#ffe1cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98442",
    d: "M13.914,29.643a.472.472,0,0,0,.447.372.581.581,0,0,0,.3.3,3.774,3.774,0,0,0,1.191.67V31.8a2.173,2.173,0,0,0,.149.67h-.074c-.3-.149-2.754-1.637-3.423-2.084,0-.6.447-1.563,1.116-1.488a3.11,3.11,0,0,1,.3.744Z",
    transform: "translate(-1.732 -12.749)",
    fill: "#ffe1cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98443",
    d: "M13.949,28.749h0L13.8,28.6l.149.149Z",
    transform: "translate(-2.064 -12.674)",
    fill: "#ffe1cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98444",
    d: "M12.327,30.229c-.744-.521.67-1.861,1.042-1.637h0l.149.149c-.67-.074-1.116.893-1.116,1.488Z",
    transform: "translate(-1.633 -12.665)",
    fill: "#c2c7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98445",
    d: "M11.3,22.033a3.891,3.891,0,0,1,.893-.333c.149.5-.223,1.334-.6.834A1.3,1.3,0,0,1,11.3,22.033Z",
    transform: "translate(-1.425 -10.909)",
    fill: "#c2c7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98446",
    d: "M10.354,29.316l.074.074v.074A18.435,18.435,0,0,0,7.674,28.2c-2.381-.447-3.051-1.414-3.274-2.084A11.108,11.108,0,0,0,7.377,25a1.984,1.984,0,0,0,1.042.521h.149a18.89,18.89,0,0,1,2.679,2.158h0c-.223-.3-1.637,1.042-.893,1.637Z",
    transform: "translate(0.34 -11.753)",
    fill: "#c2c7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98447",
    d: "M11.188,22.367c.372.521.744-.3.6-.744h0c.223-.074.521-.149.819-.223a1.276,1.276,0,0,1,1.265.967c.074.521.3,1.861.3,2.381-.074-.6-1.712,0-1.637.521-.074-.074-.074-.074-.074-.149-.149-.3-.372-.67-.521-.967-.074-.149-.67.6-1.786.447h0a2.2,2.2,0,0,1-.3-.223L9.7,23.409a2.92,2.92,0,0,0,.6-1.042A2.328,2.328,0,0,1,11.04,22c0,.149.074.223.149.372Z",
    transform: "translate(-1.015 -10.832)",
    fill: "#c2c7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98448",
    d: "M11.835,20.549c-.3.074-.6.223-.893.3-.3-.372-.67-.967-1.042-1.488,0-.521.074-1.042.074-1.414a.725.725,0,0,0,.6-.744l1.265,3.349Z",
    transform: "translate(-1.066 -9.758)",
    fill: "#ffe1cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98449",
    d: "M9.8,17.064c.3-.149.6-.149.67.074a.725.725,0,0,1-.6.744h0A1.478,1.478,0,0,0,9.8,17.064Z",
    transform: "translate(-1.041 -9.697)",
    fill: "#fd672e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98450",
    d: "M9.749,17.1a3.053,3.053,0,0,1,.074.819L9.6,17.174Z",
    transform: "translate(-0.99 -9.732)",
    fill: "#fd672e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98451",
    d: "M10.125,18h0c0,.477-.11.955-.11,1.512a10.267,10.267,0,0,0-1.207-1.193c-.329-.4.219-.875.987-1.114Z",
    transform: "translate(-1.217 -9.832)",
    fill: "#fd672e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98452",
    d: "M9.6,16.6a1.627,1.627,0,0,1,.223.372l-.149.074Z",
    transform: "translate(-0.99 -9.604)",
    fill: "#fd672e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98453",
    d: "M9.368,25.041a1.285,1.285,0,0,1,.3.223H9.516c-.372-.074-.818.074-1.116-.223A5.349,5.349,0,0,0,9.618,24l-.1,1.269Z",
    transform: "translate(-0.683 -11.496)",
    fill: "#c2c7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98454",
    d: "M9.4,23.221l.67-.521a4.745,4.745,0,0,1-.6,1.042L9.4,23.519s0-.149,0-.3Z",
    transform: "translate(-0.939 -11.165)",
    fill: "#fd672e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98455",
    d: "M9.067,23.623l.074.223a6.71,6.71,0,0,1-.744.67,1.557,1.557,0,0,1-.3-.447l.967-.67c0,.149,0,.3,0,.223Z",
    transform: "translate(-0.606 -11.344)",
    fill: "#fd672e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98456",
    d: "M7.063,13.7v.447a2.265,2.265,0,0,1-1.563.074c0-.149.074-.372.074-.521Z",
    transform: "translate(0.059 -8.863)",
    fill: "#ffe1cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98457",
    d: "M7.012,12.617H5.523A6.754,6.754,0,0,0,5.3,9.64a1.187,1.187,0,0,0,1.116.149c.6-.223,1.042-.67,1.637.149h0a2.19,2.19,0,0,1-.819,2.977c-.074.074-.149.074-.223.149v-.447Z",
    transform: "translate(0.11 -7.779)",
    fill: "#ffe1cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98458",
    d: "M7.037,15.072c.074.149.3.744-.447.819a.927.927,0,0,1-1.116-.6c0-.074-.074-.149-.074-.223V15l.893-.223a2.792,2.792,0,0,1,.744-.074S7.037,15.072,7.037,15.072Z",
    transform: "translate(0.085 -9.118)",
    fill: "#ffe1cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98459",
    d: "M7.037,14.623c-.223,0-.521.074-.744.074a3.925,3.925,0,0,0-.893.223v-.074c0-.149.074-.223.074-.372A2.265,2.265,0,0,0,7.037,14.4v.223Z",
    transform: "translate(0.085 -9.042)",
    fill: "#ffe1cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98460",
    d: "M4.15,24.784c-.074-.3,3.641-2.308,3.715-2.382.074,0,.572.145.646.368l-.089.129c.074.149-1.2,1.213-1.05,1.287A20.389,20.389,0,0,1,4.4,25.3a2,2,0,0,1-.3-.7Z",
    transform: "translate(0.419 -11.089)",
    fill: "#fd672e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98461",
    d: "M4.077,9.343a2.335,2.335,0,0,1,3.211-.2,2.05,2.05,0,0,1,.287.57c-.6-.819-1.042-.372-1.637-.149a1.187,1.187,0,0,1-1.116-.149,6.754,6.754,0,0,1,.223,2.977H4.9v.521c-.3-.149-.547-.117-.77-.266a2.9,2.9,0,0,1-.154-3.567Z",
    transform: "translate(0.589 -7.557)",
    fill: "#fdce45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98462",
    d: "M5.4,13.7h.149c0,.149-.074.372-.074.521H5.4V13.7Z",
    transform: "translate(0.085 -8.863)",
    fill: "#fdce45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98463",
    d: "M5.474,14.4c0,.149-.074.223-.074.372l.074-.372Z",
    transform: "translate(0.085 -9.042)",
    fill: "#fdce45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98464",
    d: "M5.047,15.1l-.447.223Z",
    transform: "translate(0.289 -9.221)",
    fill: "#fdce45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98465",
    d: "M4.188,20.044a1.684,1.684,0,0,1-1.34-.074c-.074-.223-.074-.447-.149-.67C3.3,19.3,4.337,19.747,4.188,20.044Z",
    transform: "translate(0.775 -10.295)",
    fill: "#fd672e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98466",
    d: "M2.9,20.2a1.684,1.684,0,0,0,1.34.074c-.149.372-.67,1.34-1.116,2.307A12.317,12.317,0,0,1,2.9,20.2Z",
    transform: "translate(0.575 -10.451)",
    fill: "#ffe1cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98467",
    d: "M8.63,16.137a.558.558,0,0,1,.074.372c-.074-.223-.372-.223-.67-.074,0-.149-.074-.223-.223-.372l.074.372c-.447.223-.893.744-.67,1.042a12.934,12.934,0,0,0,.819,1.116,5.83,5.83,0,0,0,.3,1.935l-.67.521c0-.223-.074-.447-.149-.447S3.793,22.612,3.867,22.91a1.058,1.058,0,0,0,.149.447h0a9.992,9.992,0,0,1-.893-2.233c.447-.967.893-1.935,1.116-2.307h0c.074,0,.074-.074.149-.149.3-.447.372-.744.6-1.116L2.9,16.658c0-.074.074-.223.074-.3l.223-.447c0-.074.074-.074.074-.149.074-.074.074-.149.149-.149a.743.743,0,0,1,.372-.3c.149-.074.223-.149.372-.223l.447-.223h0c.074,0,.074,0,.149-.074v.074a.9.9,0,0,0,.893.893.273.273,0,0,0,.223-.074c.744-.149.6-.67.447-.819V14.5c.967,0,1.563.149,2.307,1.637Z",
    transform: "translate(0.724 -9.067)",
    fill: "#fd672e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98468",
    d: "M2.907,17.194l2.118,1.018c-.223.372-.39.772-.688,1.219,0,.074-.074.074-.149.149.149-.3-.893-.819-1.488-.744A5.841,5.841,0,0,1,2.907,17.194Z",
    transform: "translate(0.77 -9.756)",
    fill: "#fd672e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98469",
    d: "M3.836,9A2.225,2.225,0,0,0,3.91,12.13a1.544,1.544,0,0,0,.744.447v.447a.073.073,0,0,0-.074.074h0a1.774,1.774,0,0,0-.819.447c-.149.074-.223.223-.372.3l-.149.149c0,.074-.074.074-.074.149a.743.743,0,0,0-.3.372.073.073,0,0,1-.074.074c-.6-1.116-.223-2.381.223-3.647-.3-1.116-.67-3.2,2.233-3.647A1.727,1.727,0,0,1,7.259,8.781v.6h0c0-.149-.149-.3-.3-.447A2.225,2.225,0,0,0,3.836,9Z",
    transform: "translate(0.83 -7.218)",
    fill: "#fdce45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98470",
    d: "M3.374,16.3c0,.074-.074.074-.074.149C3.3,16.374,3.374,16.374,3.374,16.3Z",
    transform: "translate(0.622 -9.528)",
    fill: "#fdce45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98471",
    d: "M2.647,17.5h0a4.4,4.4,0,0,0-.074,1.414.409.409,0,0,0-.372.223A5.276,5.276,0,0,1,2.647,17.5Z",
    transform: "translate(0.903 -9.835)",
    fill: "#fd672e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98472",
    d: "M2.7,19.3a2.173,2.173,0,0,0,.149.67q-.447-.223-.447-.447c0-.149.149-.223.3-.223Z",
    transform: "translate(0.852 -10.295)",
    fill: "#fd672e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98473",
    d: "M-.429,25.4c.223-.149-.967-.149-1.191-.149-.6,0-.3-.819-.074-.967a1.332,1.332,0,0,1,1.34.223.358.358,0,0,0,.447-.149v-.074c.074-.67,1.042-4.688,1.042-4.688,0,.149.223.3.447.447h0A12.9,12.9,0,0,0,1.8,22.428L.538,24.958c-.149.3-.223.6-.67.744s-.893.3-.893.149.372-.223.6-.447Z",
    transform: "translate(1.97 -10.372)",
    fill: "#ffe1cd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46223",
    transform: "translate(0 0.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98474",
    d: "M16,29l.67.447c.074.074.149.074.3.223",
    transform: "translate(-2.627 -12.823)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98475",
    d: "M13.847,28.263c-.149-.6-.372-1.265-.447-1.563",
    transform: "translate(-1.962 -12.235)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98476",
    d: "M15.6,26c.074.67.149,1.563.3,2.233a2.394,2.394,0,0,1,.074.6.38.38,0,0,1-.3.372",
    transform: "translate(-2.524 -12.055)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98477",
    d: "M10.942,21.588c-.3-.372-.67-.967-1.042-1.488",
    transform: "translate(-1.066 -10.546)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1308",
    x2: 1.34,
    y2: 3.349,
    transform: "translate(9.429 7.396)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98478",
    d: "M10.3,22.393a2.328,2.328,0,0,1,.744-.372,4.2,4.2,0,0,1,.893-.3h0c.223-.074.521-.149.819-.223a1.276,1.276,0,0,1,1.265.967c.074.521.3,1.861.3,2.381h0c0,.521-1.191.893-1.637.521-.074-.074-.074-.074-.074-.149-.149-.3-.372-.67-.521-.967-.074-.149-.67.6-1.786.447",
    transform: "translate(-1.169 -10.904)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98479",
    d: "M16.107,30.758a10.1,10.1,0,0,1-.893-.893c-.3-.3-.6-.521-.819-.744a1.973,1.973,0,0,0-.447-.372h0c-.074-.074-.149-.074-.149-.149",
    transform: "translate(-2.064 -12.721)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98480",
    d: "M12.5,30.9c.6.447,3.126,1.935,3.423,2.084H16",
    transform: "translate(-1.732 -13.309)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98481",
    d: "M8.319,25.4a1.285,1.285,0,0,1,.3.223h0A18.89,18.89,0,0,1,11.3,27.781l.149.149c-.67-.074-1.116.893-1.116,1.488v.074a18.435,18.435,0,0,0-2.754-1.265c-2.381-.447-3.051-1.414-3.274-2.084",
    transform: "translate(0.366 -11.902)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98482",
    d: "M7.6,14.695c.893-.074,1.563.074,2.233,1.563a.626.626,0,0,1,.125.4c0,.372-.1.72-.476.795",
    transform: "translate(-0.478 -9.16)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98483",
    d: "M5.2,15.074c.074,0,.074,0,.149-.074",
    transform: "translate(0.136 -9.242)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98484",
    d: "M3.4,16.147c.074-.074.074-.149.149-.149a.743.743,0,0,1,.372-.3",
    transform: "translate(0.596 -9.421)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98485",
    d: "M2.9,17.4c0-.074.074-.223.074-.3",
    transform: "translate(0.724 -9.779)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98486",
    d: "M8.286,18.2c0,.447-.074.893-.074,1.414a5.83,5.83,0,0,0,.3,1.935,4.745,4.745,0,0,1-.6,1.042,6.71,6.71,0,0,1-.744.67,20.389,20.389,0,0,1-2.977,1.116h0A9.992,9.992,0,0,1,3.3,22.144",
    transform: "translate(0.622 -10.06)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98487",
    d: "M9.6,16.6a1.627,1.627,0,0,1,.223.372,3.053,3.053,0,0,1,.074.819",
    transform: "translate(-0.99 -9.651)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1309",
    transform: "translate(8.908 8.14)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98488",
    d: "M2.994,20.1c-.149.372-.67,1.34-1.116,2.307L.612,24.933c-.149.3-.223.6-.67.744s-.893.3-.893.149.3-.3.521-.521-.967-.149-1.191-.149c-.6,0-.3-.819-.074-.967a1.332,1.332,0,0,1,1.34.223.358.358,0,0,0,.447-.149v-.074c.074-.67,1.042-4.688,1.042-4.688",
    transform: "translate(1.97 -10.393)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98489",
    d: "M5.4,14.772V15a.9.9,0,0,0,.893.893.273.273,0,0,0,.223-.074c.744-.149.6-.67.447-.819v-.6",
    transform: "translate(0.085 -9.088)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98490",
    d: "M5.5,13.326a2.265,2.265,0,0,0,1.563-.074,2.165,2.165,0,0,0,1.191-2.828c0-.074-.074-.149-.149-.223",
    transform: "translate(0.059 -8.014)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98491",
    d: "M4.8,12.063A6.754,6.754,0,0,0,4.58,9.086,1.187,1.187,0,0,0,5.7,9.235c.6-.223,1.042-.67,1.637.149h0A1.839,1.839,0,0,0,5.845,7.3h-.6c-2.9.447-2.53,2.53-2.233,3.647-.447,1.265-.819,2.53-.223,3.647a.073.073,0,0,1,.074-.074l.223-.447c0-.074.074-.074.074-.149.074-.074.074-.149.149-.149a.743.743,0,0,1,.372-.3c.149-.074.223-.149.372-.223l.447-.223h0a.073.073,0,0,0,.074-.074v-.074c0-.149.074-.223.074-.372.074-.074.074-.3.149-.447Z",
    transform: "translate(0.83 -7.272)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98492",
    d: "M4.83,18.293c-.223.372-.3.67-.6,1.116,0,.074-.074.074-.149.149h0a1.684,1.684,0,0,1-1.34-.074q-.447-.223-.447-.447A6.71,6.71,0,0,1,2.747,17.4",
    transform: "translate(0.878 -9.856)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98493",
    d: "M18.265,30.828c0,.223.074.372.074.6,0,.447.149,1.488-.447,1.637a.819.819,0,0,1-.744-.447,1.106,1.106,0,0,1-.149-.67v-.967h0a2.446,2.446,0,0,1,.3-1.265l.223-.223C17.967,29.265,18.191,30.158,18.265,30.828Z",
    transform: "translate(-2.883 -12.939)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98494",
    d: "M26.955,31.423c.372.447-.149,1.116-.893,1.563-.819.447-1.563.967-2.381.521s-.074-1.34,1.042-1.935c.223-.149.521-.223.744-.372",
    transform: "translate(-4.503 -13.386)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98495",
    d: "M44.2,24.1a1.335,1.335,0,0,0,.521.372,2.666,2.666,0,0,0,.819.3c.447.074.819.223.967.074.223-.223,0-.223-.372-.67-.223-.223.967-.372,1.116-.447.223-.149,0-.447-.372-.67a1.268,1.268,0,0,0-1.042,0,2.262,2.262,0,0,1-.521.372h-.149",
    transform: "translate(-9.84 -11.275)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98496",
    d: "M26.821,30a7.8,7.8,0,0,0-.6.819c-.074.074-.074.149-.149.149-.3.372.447.893.967.6a2.006,2.006,0,0,0,.6-.521,1.973,1.973,0,0,1,.447-.372",
    transform: "translate(-5.187 -13.079)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98497",
    d: "M40.3,20.2v.074",
    transform: "translate(-8.843 -10.572)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98498",
    d: "M35.148,17.413A1.9,1.9,0,0,1,35,15.18a1.5,1.5,0,0,1,1.563-.223",
    transform: "translate(-7.412 -9.199)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98499",
    d: "M39.2,15.5a1.984,1.984,0,0,1,1.042.521A7.558,7.558,0,0,1,41.879,18.4c.819,1.414,1.34,2.158,1.786,2.828a.273.273,0,0,1,.074.223A.746.746,0,0,1,43,22.2h-.074a.612.612,0,0,1-.447-.3c-.372-.521-1.563-1.935-2.456-2.9A10.605,10.605,0,0,0,39.2,18.1",
    transform: "translate(-8.561 -9.37)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98500",
    d: "M32.591,21.712A17.478,17.478,0,0,0,28.349,20H28.2",
    transform: "translate(-5.748 -10.521)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98501",
    d: "M28.55,25.686c-.6.819-1.191,1.712-1.488,2.158a.453.453,0,0,0,0,.6,1.462,1.462,0,0,0,1.265.67.755.755,0,0,0,.744-.223c.447-.6,1.488-1.935,1.712-2.233s.372-.819.967-.67a6.356,6.356,0,0,0,3.721.149,1.518,1.518,0,0,0,.893-1.935.564.564,0,0,0-.149-.3",
    transform: "translate(-5.428 -11.518)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98502",
    d: "M34.284,24.144l-1.563-.6A1.38,1.38,0,0,0,32.2,23.4",
    transform: "translate(-6.771 -11.39)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98503",
    d: "M35.063,17.4c0,.223-.074.447-.074.67a3.126,3.126,0,0,1-.447,1.563,2.45,2.45,0,0,0-.447,1.414,1.636,1.636,0,0,0,.67,1.563.564.564,0,0,0,.3.149,2.477,2.477,0,0,0,2.9-.3l.074-.074c.3-.6.149-1.861.744-2.828",
    transform: "translate(-7.252 -9.856)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98504",
    d: "M37.2,14.823v.447a.509.509,0,0,0,.521.521.944.944,0,0,0,.447-.074.564.564,0,0,0,.3-.149.409.409,0,0,0,.223-.372v-.6",
    transform: "translate(-8.05 -9.139)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98505",
    d: "M35.2,11.265A1.462,1.462,0,0,1,35.87,10",
    transform: "translate(-7.538 -7.963)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98506",
    d: "M38.913,13.561h0a1.757,1.757,0,0,1-.67.447,2.265,2.265,0,0,1-1.563.074A2.135,2.135,0,0,1,35.192,11.7",
    transform: "translate(-7.53 -8.398)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98507",
    d: "M28.845,23.5a.273.273,0,0,1-.223-.074,6.69,6.69,0,0,1-1.935-1.265A1.314,1.314,0,0,1,27.654,20h.223a.99.99,0,0,1,.6.223,11.239,11.239,0,0,1,2.084,1.637.554.554,0,0,1,.074.67.564.564,0,0,1-.149.3",
    transform: "translate(-5.276 -10.521)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98508",
    d: "M39.365,12.277c.149,0,.223-.074.3-.223h0a.259.259,0,0,0,.074-.372l-.074-.074c.074,0,.074-.074.149-.074a.36.36,0,0,0,0-.521h-.074c.074,0,.149-.074.223-.149s.074-.149.074-.3a1.634,1.634,0,0,0,.372-.893.32.32,0,0,0-.3-.3h0a2.06,2.06,0,0,0-.074-.67.331.331,0,0,0-.447-.149.073.073,0,0,0-.074.074,1.865,1.865,0,0,0-.3-.521.279.279,0,0,0-.447,0,.073.073,0,0,1-.074.074,1.544,1.544,0,0,0-.447-.744c-.149-.074-.372-.074-.447.074h0c0,.074-.074.074-.074.149h-.149l-.223-.223a.474.474,0,0,0-.447,0h0c0,.074-.074.074-.074.149a1.557,1.557,0,0,0-.447-.3.251.251,0,0,0-.372.223c-.074.149,0,.223.074.3h-.074c-.149-.074-.3.074-.372.223h0v.223a.944.944,0,0,0-.447-.074.3.3,0,1,0,0,.6c.074,0,.372.074.372.521v.074c.074.223.3.3.521.372h.074v.074a.32.32,0,0,0,.3.3h0c.074,0,.223-.074.223-.149v.074a.32.32,0,0,0,.3.3h0c.074,0,.223-.074.223-.149.074.149.149.223.3.223h0c.074,0,.149-.074.223-.074h0a.32.32,0,0,0,.3.3H38.1a.073.073,0,0,0,.074.074c-.074,0-.074.074-.149.149-.074.149,0,.223.074.3h.149c-.074.074,0,.3.223.3",
    transform: "translate(-7.461 -7.263)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98509",
    d: "M40.1,12.674h0c.074,0,.149-.074.223-.074h.149c.074,0,.149.074.223.074a.579.579,0,0,1,.149.6.387.387,0,0,1-.149.3.628.628,0,0,1-.521.149H40.1a.581.581,0,0,1-.3-.3",
    transform: "translate(-8.715 -8.628)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98510",
    d: "M31.425,23.675c-.074,0-.074-.074-.149-.074a1.627,1.627,0,0,0-.372-.223,1.627,1.627,0,0,1-.372-.223.677.677,0,0,0-.893.074.394.394,0,0,0-.074.6h0l.3.3",
    transform: "translate(-6.07 -11.293)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98511",
    d: "M32.221,24.023a.581.581,0,0,1,.3.3A1.4,1.4,0,0,1,31.4,25.884c-1.34.447-2.009.223-2.233-.223,0-.074-.074-.074-.074-.149a1.144,1.144,0,0,1,.447-1.042c.074-.074.223-.149.3-.223.149-.074.223-.149.372-.223.074,0,.149-.074.223-.074a2.173,2.173,0,0,1,.67-.149h.223a3.925,3.925,0,0,1,.893.223Z",
    transform: "translate(-5.973 -11.493)",
    fill: "none",
    stroke: "#1228f3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchPartnersSmall);
export default __webpack_public_path__ + "static/media/launch-partners-small.d186e136727bf36e13bff126c7157e25.svg";
export { ForwardRef as ReactComponent };